// Travel Insurance Change Plan Flow Constants
export const TRAVEL_CHANGE_PLAN_SELECT_NEW_PLAN = "TRAVEL_CHANGE_PLAN_SELECT_NEW_PLAN";
export const TRAVEL_CHANGE_PLAN_REVIEW_AND_CONFIRM = "TRAVEL_CHANGE_PLAN_REVIEW_AND_CONFIRM";